import React, { type ReactNode, type ReactElement } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import BreadcrumbRenderer from '@atlassian/jira-breadcrumbs/src/breadcrumb-renderer/index.tsx';
import PageHeader from '@atlassian/jira-common-components-page-header';
import { useIntl } from '@atlassian/jira-intl/src/index.tsx';
import messages from '../i18n/messages';

type Props = {
	// Redefine props from atlaskit/page-header.
	actions: ReactElement | undefined;
	bottomBar: ReactElement | undefined;
	children: ReactNode | undefined;
	showDefaultTitle: boolean;
	/**
	 * If defined will override bottomBar by placing a negative top margin to place text closer to title
	 */
	description: ReactNode | undefined;
};

export function KnowledgeHubPageHeader(props: Props) {
	const { children, description, showDefaultTitle, bottomBar, ...restProps } = props;
	const { formatMessage } = useIntl();

	return (
		<PageHeader
			truncateTitle
			bottomBar={description ? <Description>{description}</Description> : bottomBar}
			breadcrumbs={<BreadcrumbRenderer />}
			{...restProps}
		>
			{children || (showDefaultTitle ? formatMessage(messages.knowledgeBase) : null)}
		</PageHeader>
	);
}

KnowledgeHubPageHeader.defaultProps = {
	actions: undefined,
	bottomBar: undefined,
	children: null,
	showDefaultTitle: true,
	description: undefined,
	onBreadcrumbClicked: undefined,
};

export default KnowledgeHubPageHeader;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Description = styled.div({
	marginTop: token('space.negative.200', '-16px'),
	overflowWrap: 'break-word',
});
